import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { Modal, FormGroup, ControlLabel, Button, FormControl, HelpBlock } from 'react-bootstrap';
import { Field, reduxForm } from 'redux-form';

class PeriodForm extends Component {
  constructor() {
    super();
    this.state = {
    };
    this.close = this.close.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.renderField = this.renderField.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.modalOpen && nextProps.modalOpen) {
      this.props.reset();
    }
  }

  close() {
    this.props.onHide();
  }

  handleSubmit(data) {
    const { valid } = this.props;
    if (!valid) {
      return;
    }
    this.props.onDayChange(parseInt(data.days, 10));
    this.props.onHide();
  }

  renderField({
    input, label, type, placeholder, meta: { touched, error },
  }) {
    const { submitting } = this.props;
    const validationState = touched && error ? 'error' : null;
    return (
      <FormGroup validationState={validationState}>
        <ControlLabel>{label}</ControlLabel>
        <FormControl {...input} placeholder={placeholder} type={type} disabled={submitting} />
        <FormControl.Feedback />
        {touched && error && <HelpBlock>{error}</HelpBlock>}
      </FormGroup>
    );
  }

  render() {
    const { handleSubmit, modalOpen, valid } = this.props;
    return (
      <Modal show={modalOpen} onHide={this.close}>
        <Modal.Header closeButton>
          Custom Period
        </Modal.Header>
        <form onSubmit={handleSubmit(this.handleSubmit)}>
          <Modal.Body>
            <Field name="days" placeholder="enter number days" type="text" component={this.renderField} label="days" />
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="link" onClick={this.close}>Cancel</Button>
            <Button bsStyle="primary" type="submit" disabled={!valid}>
              Apply
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    );
  }
}

PeriodForm.propTypes = {
  dispatch: PropTypes.func.isRequired,
  onHide: PropTypes.func,
  modalOpen: PropTypes.bool,
  reset: PropTypes.func.isRequired,
  maxValue: PropTypes.number,
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool,
  valid: PropTypes.bool,
  onDayChange: PropTypes.func,
};

PeriodForm.defaultProps = {
  modalOpen: false,
  onHide: () => {},
  maxValue: 0,
  valid: false,
  submitting: false,
  onDayChange: () => {},
};

// Retrieve data from store as props
function mapStateToProps() {
  return {};
}


const validate = (values) => {
  const errors = {};
  if (!values.days) {
    errors.days = 'Please provide a value';
  } else if (Number.isNaN(Number(values.days))) {
    errors.days = 'Must be a number';
  } else if (Number(values.days) !== parseInt(values.days, 10)) {
    errors.days = 'Must be an integer';
  } else if (Number(values.days) <= 0) {
    errors.days = 'Minimum value is 1';
  }
  return errors;
};

const ReduxPeriodForm = reduxForm({
  form: 'periodForm',
  validate,
})(PeriodForm);

export default connect(mapStateToProps)(ReduxPeriodForm);
